import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Link as MuiLink, Typography } from "@material-ui/core";
import { TicketQueue, TicketFilters } from "helpers/enums";
import { applicationContext } from "helpers/services";
import { useContext, useEffect, useState } from "react";
import { ticketsContext } from "views/Tickets/TicketsContext";


let FilterDialog = ({ queue }: { queue: TicketQueue | "" }) => {

    let { userFilters, setUserFilters } = useContext(applicationContext)
    let { saveSelectedFilters, filtersByQueue, filterLabel } = useContext(ticketsContext)

    let [selectedFilters, setSelectedFilters] = useState<TicketFilters[]>([])
    let [isOpen, setOpen] = useState(false);


    useEffect(() => {
        if (isOpen === true)
            setSelectedFilters(userFilters)
    }, [isOpen])


    let saveFilters = () => {
        setUserFilters(selectedFilters)
        saveSelectedFilters(selectedFilters)
        setOpen(false)
    }


    return (
        <>
            <MuiLink
                component="button"
                color="secondary"
                variant="body2"
                onClick={(e) => {
                    e.preventDefault()
                    setOpen(true)
                }}
            >
                FILTERS
            </MuiLink>

            <Dialog open={isOpen} fullWidth maxWidth="sm">
                <DialogTitle disableTypography>
                    <Typography variant="h4">Choose filters to show on tickets search</Typography>
                </DialogTitle>

                <DialogContent>
                    <Grid container>
                        {filtersByQueue
                            .getValueByKey(queue)
                            .map((filter: TicketFilters) =>
                                <Grid item xs={6} key={filter}>
                                    <FormControlLabel
                                        control={<Checkbox checked={selectedFilters.indexOf(filter) !== -1} />}
                                        label={filterLabel[filter]}
                                        onChange={(e: any) => {
                                            if (e.target.checked) {
                                                setSelectedFilters([...selectedFilters, filter])
                                            } else {
                                                setSelectedFilters(selectedFilters.filter(x => x !== filter))
                                            }
                                        }}
                                    />
                                </Grid>
                            )
                        }
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button
                        color="primary"
                        onClick={() => setOpen(false)}>
                        Cancel
                    </Button>
                    <Button
                        color="secondary"
                        onClick={saveFilters}
                    >
                        Confirm
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    )
}

export default FilterDialog